import { useMediaQuery, useTheme } from '@material-ui/core';

import isMobileOrTablet from 'app/shared/helpers/isMobileOrTablet';

export function useIsPersonalDataTwoAdvantagesView(): boolean {
  const theme = useTheme();
  const isNarrowViewport = useMediaQuery(theme.breakpoints.down('sm'));

  return !isNarrowViewport && !isMobileOrTablet();
}
